import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import o from "../../core/Handles.js";
import { init as r } from "../../core/watchUtils.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { GoToMixin as a } from "../support/GoTo.js";
var n = "esri.widgets.CompassViewModel";

var h = /*#__PURE__*/function (_a) {
  _inherits(h, _a);

  var _super = _createSuper(h);

  function h(t) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this, t), _this._handles = new o(), _this.orientation = {
      x: 0,
      y: 0,
      z: 0
    }, _this.view = null, _this._updateForCamera = _this._updateForCamera.bind(_assertThisInitialized(_this)), _this._updateForRotation = _this._updateForRotation.bind(_assertThisInitialized(_this)), _this._updateRotationWatcher = _this._updateRotationWatcher.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(h, [{
    key: "initialize",
    value: function initialize() {
      this._handles.add(r(this, "view", this._updateRotationWatcher));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._handles.destroy(), this._handles = null, this.view = null;
    }
  }, {
    key: "canShowNorth",
    get: function get() {
      var t = this.get("view.spatialReference");
      return !(!t || !t.isWebMercator && !t.isGeographic);
    }
  }, {
    key: "state",
    get: function get() {
      return this.get("view.ready") ? this.canShowNorth ? "compass" : "rotation" : "disabled";
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this.get("view.ready")) return;
      var t = {};
      "2d" === this.view.type ? t.rotation = 0 : t.heading = 0, this.callGoTo({
        target: t
      });
    }
  }, {
    key: "_updateForRotation",
    value: function _updateForRotation(t) {
      null != t && (this.orientation = {
        z: t
      });
    }
  }, {
    key: "_updateForCamera",
    value: function _updateForCamera(t) {
      if (!t) return;
      var e = -t.heading;
      this.orientation = {
        x: 0,
        y: 0,
        z: e
      };
    }
  }, {
    key: "_updateRotationWatcher",
    value: function _updateRotationWatcher(t) {
      this._handles.removeAll(), t && ("2d" === t.type ? this._handles.add(r(this, "view.rotation", this._updateForRotation)) : this._handles.add(r(this, "view.camera", this._updateForCamera)));
    }
  }]);

  return h;
}(a(e));

t([s({
  readOnly: !0
})], h.prototype, "canShowNorth", null), t([s()], h.prototype, "orientation", void 0), t([s({
  readOnly: !0
})], h.prototype, "state", null), t([s()], h.prototype, "view", void 0), h = t([i(n)], h);
var d = h;
export { d as default };